module.exports = __webpack_public_path__ + "static/media/nexaslim-5.c73434dd.png";